import { createReducer, on } from '@ngrx/store';
import { masterInitialState } from '@store/states/master.state';
import { masterActions } from '@store/actions/master.actions';

export const masterReducer = createReducer(
  masterInitialState,
  on(masterActions.setSocieties, (state, actionData) => ({
    ...state,
    societies: actionData.data,
    errorSocieties: null,
  })),
  on(masterActions.errorSocieties, (state, actionData) => ({
    ...state,
    societies: null,
    errorSocieties: actionData.error,
  })),
  on(masterActions.setInstallations, (state, actionData) => ({
    ...state,
    installations: actionData.data,
    errorInstallations: null,
  })),
  on(masterActions.errorInstallations, (state, actionData) => ({
    ...state,
    installations: null,
    errorInstallations: actionData.error,
  })),
  on(masterActions.setRoadTypes, (state, actionData) => ({
    ...state,
    roadTypes: actionData.data,
    errorRoadTypes: null,
  })),
  on(masterActions.errorRoadTypes, (state, actionData) => ({
    ...state,
    roadTypes: null,
    errorRoadTypes: actionData.error,
  })),
  on(masterActions.setSelfConsumptions, (state, actionData) => ({
    ...state,
    selfConsumptions: actionData.data,
    errorSelfConsumptions: null,
  })),
  on(masterActions.errorSelfConsumptions, (state, actionData) => ({
    ...state,
    selfConsumptions: null,
    errorSelfConsumptions: actionData.error,
  }))
);
